"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVATAR_TYPES = exports.AVATAR_SIZES = exports.AVATAR_NOTIFICATION = exports.AVATAR_COLORS = void 0;
var AVATAR_TYPES = exports.AVATAR_TYPES = {
  CIRCLE: 'avatar--circle',
  SQUARE: 'avatar--square'
};
var AVATAR_SIZES = exports.AVATAR_SIZES = {
  XSMALL: 'avatar--xs',
  SMALL: 'avatar--sm',
  MEDIUM: 'avatar--md',
  LARGE: 'avatar--lg',
  XLARGE: 'avatar--xl'
};
var AVATAR_COLORS = exports.AVATAR_COLORS = {
  PRIMARY: 'avatar--primary',
  PRIMARY_DARK: 'avatar--primary-dark',
  PRIMARY_DARKER: 'avatar--primary-darker',
  SECONDARY: 'avatar--secondary',
  WHITE: 'avatar--white',
  CONTRAST_LOW: 'avatar--contrast-low'
};
var AVATAR_NOTIFICATION = exports.AVATAR_NOTIFICATION = {
  NONE: '',
  WARNING: 'avatar--notification-warning',
  SUCCESS: 'avatar--notification-success',
  ERROR: 'avatar--notification-error',
  TEXT: 'avatar--notification-text'
};